import React from 'react';
import { useDispatch } from 'react-redux';
import { SpeakerEntry, StageComponentInterface } from '../../../../interfaces/pagebuilder';
import { setSpeakerModal } from '../../../../reduxToolkit/slices/commonSlice';
import MBWAgendaEntry from './MBWAgendaEntry';

const MbwStageAgenda = ({ uiComponent }: { uiComponent: StageComponentInterface }) => {
  const dispatch = useDispatch();

  const sortedEntries = [...(uiComponent?.entryList || [])].sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());

  if (!uiComponent) return null;

  function handleOpenSpeaker(speaker: SpeakerEntry) {
    if (!speaker) return;
    dispatch(
      setSpeakerModal({
        speaker,
      })
    );
  }

  return (
    <div className="flex flex-col w-full">
      <span className="text-xl font-bold pt-4 pl-4 pr-4 pb-4">{uiComponent?.agendaTitle}</span>
      <div className="flex flex-col items-start justify-start pl-6 md:pl-0">
        {sortedEntries.map((e, index) => (
          <MBWAgendaEntry
            customFontSize={18}
            key={index + e.title}
            entry={e}
            openSpeaker={handleOpenSpeaker}
            uiComponent={uiComponent}
            withHoverAnimation={false}
          />
        ))}
      </div>
    </div>
  );
};

export default MbwStageAgenda;
